import React from 'react';
import { Button } from '../ui/button';
import { useConsent } from '../../context/ConsentContext';
import ConsentPreferencesDialog from './ConsentPreferencesDialog';
import { marketingUrl } from '../../config/urls';

/**
 * Global cookie-consent banner. Mounted once in RootLayout so it appears on
 * every route. Shows only until the visitor makes an explicit choice
 * (`bannerVisible` = `!consent.decided`) — there is no dismiss/close control
 * that implicitly grants consent; the only ways to make it go away are the
 * three explicit actions below (or saving preferences in the Customize
 * dialog). "Accept All" and "Reject Non-Essential" use the same button
 * style/size so neither is visually favored over the other.
 */
const ConsentBanner = () => {
  const {
    bannerVisible, acceptAll, rejectNonEssential, openPreferences,
  } = useConsent();

  return (
    <>
      {bannerVisible && (
        <div
          role="region"
          aria-label="Cookie consent"
          className="fixed inset-x-0 bottom-0 z-[100] border-t border-border bg-background px-4 py-4 shadow-even-md sm:px-6"
        >
          <div className="mx-auto flex max-w-5xl flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-sm text-foreground">
              We use essential cookies to run atEaseAI, and, with your permission, optional
              cookies for analytics (Google Analytics, PostHog) and visitor identification
              (RB2B). Read our{' '}
              <a href={marketingUrl('/cookie-policy')} className="underline hover:text-primary">
                Cookie Policy
              </a>{' '}
              for details.
            </p>
            <div className="flex flex-shrink-0 flex-wrap gap-2 sm:justify-end">
              <Button variant="default" size="sm" onClick={rejectNonEssential}>
                Reject Non-Essential
              </Button>
              <Button variant="default" size="sm" onClick={acceptAll}>
                Accept All
              </Button>
              <Button variant="outline" size="sm" onClick={openPreferences}>
                Customize
              </Button>
            </div>
          </div>
        </div>
      )}
      <ConsentPreferencesDialog />
    </>
  );
};

export default ConsentBanner;
